'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('SalesSupport', ['Role', function(Role) {
    class SalesSupport extends Role {
        isAuthorizedToUpdateOrder(order) {
            return order && order.editable;
        }

        isAuthorizedToCreateOrderNotification(order) {
            return order && order.editable;
        }

        isAuthorizedToCreateOrderLineItem(order) {
            return order && order.editable;
        }

        isAuthorizedToUpdateLineItem(order) {
            return order && order.editable;
        }

        isAuthorizedToDeleteLineItem(lineItem, order) {
            return this._isAuthorizedToDeleteLineItem && lineItem && lineItem.deletable && order && order.editable;
        }

        isAuthorizedToCopyLineItem(order) {
            return order && order.editable;
        }

        isAuthorizedToUpdateLineItemCampaignManager(order) {
            return order && order.editable;
        }

        isAuthorizedToCopyFlight(order) {
            return order && order.editable;
        }

        isAuthorizedToUpdateFlight(order) {
            return order && order.editable;
        }

        isAuthorizedToDeleteFlight(order) {
            return order && order.editable;
        }
    }

    return SalesSupport.newFrozenInstance(
        'ListClusters',
        'ListOrders',
        'ViewOrder',
        'UpdateOrder',
        'CancelOrder',
        'CopyOrder',
        'ShowOrderAuditHistory',
        'ShowOrderBuySheet',
        'CreateOrderNotification',
        'CreateOrderComment',
        'ListOrderComments',
        'DeleteOrderComment',
        'ListOrderTasks',
        'ShowOrderTask',
        'CreateOrderTask',
        'ListOrderLineItems',
        'CreateOrderLineItem',
        'ViewLineItem',
        'UpdateLineItem',
        'CancelLineItem',
        'CopyLineItem',
        'ViewFlight',
        'UpdateFlight',
        'CancelFlight',
        'CopyFlight',
        'ShowLineItemAuditHistory',
        'ShowLineItemDownloadPdf',
        'UpdateLineItemCampaignManager',
        'CreateLineItemComment',
        'ListLineItemComments',
        'DeleteLineItemComment',
        'ListLineItemTasks',
        'ShowLineItemTask',
        'CreateLineItemTask'
    )
}]);